import { Button } from '@cian/ui-kit';
import * as React from 'react';

import styles from './index.css';
import { NavigationLinkTypes } from '../../constants/navigation';
import { VILLAGES_COUNT_KEYS } from '../../interfaces/village';
import { trackGotoListingDeveloperClick, trackShowFullInfoClick } from '../../tracking';
import { IVillageSchema, MODERATION_STATUS_TYPES } from '../../types';
import { ClipboardModify } from '../common/ClipboardModify';
import { Description } from '../common/description';
import { Phone } from '../phone';
import { VillagesCount } from '../villages_count';

export interface IAboutBuilderMainProps {
  setNavigationLink(): void;
  trackShowPhoneClick(): void;
  village: IVillageSchema;
}

interface IAboutBuilderMainState {
  isPhoneVisible: boolean;
}

export class AboutBuilderMain extends React.Component<IAboutBuilderMainProps, IAboutBuilderMainState> {
  public state = {
    isPhoneVisible: false,
  };

  public componentDidMount() {
    if (this.shouldBuilderRender()) {
      this.props.setNavigationLink();
    }
  }

  public shouldBuilderRender = () => this.props.village.builder?.moderationStatus === MODERATION_STATUS_TYPES.Published;

  public render() {
    const { village } = this.props;
    const { builder } = village;

    if (!builder || !this.shouldBuilderRender()) {
      return null;
    }

    const builderImage = {
      backgroundImage: `url(${builder.logoUrl})`,
    };

    const { name, logoUrl, counterSet = {}, seo, description = '', displayPhone, phone } = builder;

    return (
      <div className={styles['container']} id={NavigationLinkTypes.Builder}>
        <ClipboardModify>
          <div>
            <div>
              <p className={styles['builder_name']}>{name}</p>
              <span className={styles['builder_badge']}>Застройщик</span>
            </div>
            <div>
              {logoUrl ? (
                <div className={styles['builder_image']} style={builderImage} />
              ) : (
                <div className={styles['default_builder']}>
                  <div className={styles['default_builder_img']} />
                </div>
              )}
            </div>
            <span className={styles['villages_count_container']}>
              <VillagesCount
                label={VILLAGES_COUNT_KEYS.SELLING}
                count={validateVillageCount(counterSet?.onSale)}
                link={seo?.onSale?.url ?? ''}
                styleCont={styles['inline']}
                onLinkClick={trackGotoListingDeveloperClick}
              />
            </span>
            <span className={styles['villages_count_container']}>
              <VillagesCount
                label={VILLAGES_COUNT_KEYS.SOLDOUT}
                count={validateVillageCount(counterSet?.sold)}
                link={seo?.sold?.url ?? ''}
                styleCont={styles['inline']}
                onLinkClick={trackGotoListingDeveloperClick}
              />
            </span>
            <noindex>
              <div className={styles['description_container']}>
                <Description
                  description={description}
                  lineCounter={3}
                  onShowFullInfoClick={() => trackShowFullInfoClick('developer_info_open')}
                />
              </div>
            </noindex>
            {displayPhone && phone && (
              <div className={styles['phone_button_container']}>
                {this.state.isPhoneVisible ? (
                  <Phone phone={phone} style={styles['phone']} />
                ) : (
                  <Button size="XS" onClick={this.handlePhoneCollapseButtonChange}>
                    Показать телефон
                  </Button>
                )}
              </div>
            )}
          </div>
        </ClipboardModify>
      </div>
    );
  }

  private handlePhoneCollapseButtonChange = () => {
    this.setState({
      isPhoneVisible: true,
    });
    this.props.trackShowPhoneClick();
  };
}

function validateVillageCount(count: number | undefined | null) {
  if (typeof count === 'undefined' || count === null) {
    return 0;
  } else {
    return count;
  }
}
